import styled from 'react-emotion';
import { LINK_COLOUR, LINK_HOVER_COLOUR, LINK_VISITED_COLOUR } from 'govuk-colours';
var Anchor = styled('a')({
  color: LINK_COLOUR,
  ':hover': {
    color: LINK_HOVER_COLOUR
  },
  ':visited': {
    color: LINK_VISITED_COLOUR
  }
});
export default Anchor;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/paragraph/es/atoms/anchor/index.js
// module id = 262
// module chunks = 0